import { Component, QueryList, ViewChildren } from '@angular/core';
import { DataService } from './../../../services/data/data.service';

import { FuncionesMes, formatear, periodos } from './../../funciones/funcionesGenerales';
import { environment } from './../../../../environments/environment';
import { EvaluacionEntity, IndicadorEntity } from './../../funciones/AlertaTemprana';
import { Detalle_Evaluacion_IndicadorEntity } from './../../funciones/AlertaTemprana';
import { formulasFunctions } from '../funciones';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { getEvaluaciones, getDetalleIndicadores, getDetalleIndicador, getIndicadores } from './../../../services/financiero/indicadores-financieros/querys';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { IMG } from '../../../services/imagen/png';
import { ExcelService } from '../../../services/excel/excel.service';

import Swal from 'sweetalert2';
import moment from 'moment';
import { messages } from '../../funciones/mensajes';
import { indicadores } from '../idsTablas';
import { companiesFinanciero } from '../../../shared/catalogos';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';

@Component({
  selector: 'app-indicadores-perlas',
  templateUrl: './indicadores-perlas.component.html',
  styleUrl: './indicadores-perlas.component.css'
})
export class IndicadoresPerlasComponent {
  public Filters = FiltersM;
  @ViewChildren(GraficadorComponent) graficador!: QueryList<GraficadorComponent>;
  /* Consultas */
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public headersCheck = [
    {check: true, color: ''},
    {check: false, color: '#72d54a'},
    {check: false, color: ''},
    {check: false, color: ''},
    {check: false, color: '#ffd100'},
    {check: false, color: ''},
    {check: false, color: '#ff495c'}];

  private numEvaluaciones = 6;
  /*Obtención de datos consultas*/
  private indicadorEntity = new IndicadorEntity;
  private evaluacionEntity = new EvaluacionEntity;
  private detalleEvaluacionIndicador = new Detalle_Evaluacion_IndicadorEntity;

  private dataNoInclud: string[] = ['EMP','GESTION'];

  private periodosSeleccionados = 0;
  /*Titulos y subtitulos*/
  public subTitles = [];
  public subTitlesGraf = '';
  public subTitlesGrafI = '';
  /*Variables filtros*/
  public Periodos = [];
  public cadenaEvaluacion = [];
  /*Arreglos*/
  public dataOrdenado = [];
  public dataGraficas = [];
  public etiquetas = [];
  public typeGraph =  typesApex;
  public tipoGraf = this.typeGraph.HEATMAP;
  public colors = ['#72D54A','#FFCB03','#FF8300','#F74C58'];
  public heatMap: boolean = true;
  public dataGrafEvolucion = [];
  public etiquetasEvolucion = [];
  public tipoGrafEvolucion = this.typeGraph.AREA;
  public showLabelEvolucion: boolean = false;
  public color = ['#76C4D5'];
  public dataIndicadores = [];
  public modalOpen: boolean = false;

  public visibleTabla = true;
  public visibleTarjeta = false;

  public indSeleccionado = undefined;
  public dataGrafIndBarras = [];
  public dataGrafIndLineal = [];

  public graf1 = false;
  public graf2 = false;

  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';

  constructor(
    public dataService: DataService,
    private apollo: Apollo,
    private translate: TranslateService,
    private cookieService: CookieService,
    private excelService: ExcelService
  ) {
    this.evaluacionEntity = new EvaluacionEntity;
    this.indicadorEntity = new IndicadorEntity;
    this.evaluacionEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.evaluacionEntity.Id_Institucion = Number(cookieService.get('idInstitucion'));
    this.indicadorEntity.Id_Plantilla = Number(cookieService.get('idPlanFin'));
    this.getEvaluacion();
  }

  ngOnInit(): void {
  }
  labelFormatting(c: any) {
    return `<span> </span>`;
  }
  valueFormatting(c: any){
    return c;
    //return '<b>'+c+'</b>';
  }
  /*Consultas*/
  private async getEvaluacion(){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getEvaluaciones,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.evaluacionEntity.Id_Plantilla }
        }).valueChanges.source
      );
      
      var aux = [];
      for(const per of data.evaluaciones){
        if(per.idInstitucion === this.evaluacionEntity.Id_Institucion){
          aux.push(per);
        }
      }
      this.ordenamientoDataEvaluacion(aux);
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getDettalleEvaluacion(){
    try{
      let datos = [];
      for(const eva of this.cadenaEvaluacion){
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleIndicadores,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id}
          }).valueChanges.source
        )

        datos = datos.concat(data.detalleEvaluacionIndicadors)
      }
      this.getIndicadores(datos);

    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private async getIndicadores(array){
    try{
      const { data } = await firstValueFrom(
        this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
          query: getIndicadores,
          context: { headers: this.headers, },
          variables: { idPlantilla: this.evaluacionEntity.Id_Plantilla }
        }).valueChanges.source
      )
      let datos = data.indicadores;
      var aux = [];
      let ordenIndi;
      switch(this.evaluacionEntity.Id_Plantilla){
        case 5: 
          ordenIndi = indicadores.indiPerlas5;
          break;
        case 8: 
          ordenIndi = indicadores.indiPerlas8;
          break;
        default: ordenIndi = [];
      }
      if(ordenIndi.length > 0){
        for(const ind of ordenIndi){
          const indMac = datos.find(c => c.id === ind.name);
          if(indMac){
            const sub = datos.filter(c => c.id.includes(indMac.id) && c.nivel === 3);

            sub.sort( function (a, b){
              if(Number(a.id.split(indMac.id)[1]) > Number(b.id.split(indMac.id)[1]))
                return 1;
              if(Number(a.id.split(indMac.id)[1]) < Number(b.id.split(indMac.id)[1]))
                return -1;
              return 0;
            });

            aux.push(indMac);
            aux = aux.concat(sub);
          }
        }
        datos = aux;
      }else{
        datos = [];
      }
      if(datos){
        let aux = [];
        for (const dat of array){
            const ind = datos.filter(ele => ele.id === dat.idIndicador)
            aux.push({
              "idEvaluacion": dat.idEvaluacion,
              "idIndicador": dat.idIndicador,
              "valor": Number(dat.valor).toFixed(2),
              "nivel": dat.nivel,
              "textoSemaforo": dat.textoSemaforo,
              "indicadorEntity": [].concat(ind),
              "formula": dat.formula,
            });
        }
        this.obtDataOrdenado(datos, aux);
      }
    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  /* eventos en tablas */
  public searchSubNivel(ind, pos){
    var con = 0;
    for(var i = pos+1; i<this.dataOrdenado.length; i++){
      if(this.dataOrdenado[i].nivel > ind.nivel){
        con++;
      }
      if(this.dataOrdenado[i].nivel === ind.nivel || this.dataOrdenado[i].nivel < ind.nivel){
        break;
      }
    }
    if(con !== 0)
      return true;
    return false;
  }
  public showHideTab(ind, pos){
    var con = 0;
    for(var i = pos+1; i<this.dataOrdenado.length; i++){
      if(this.dataOrdenado[i].nivel > ind.nivel){
        this.dataOrdenado[i].check = !this.dataOrdenado[i].check; 
      }
      if(this.dataOrdenado[i].nivel === ind.nivel || this.dataOrdenado[i].nivel < ind.nivel){
        break;
      }
    }
    this.obtenerDataGrafica();
  }
  /*Obtención de datos*/
  private ordenamientoDataEvaluacion(datos){
    const info = periodos.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for(const an of this.Periodos){
      if(an.anio < 2023){
        an.utilizable = false;
      }
    }
    this.periodosSeleccionados = info.perSel;
    this.UltimasEvaluaciones();
  }
  private async obtDataOrdenado(data, dataAll){
    this.dataOrdenado = [];
    var arrayElemetos = [];
    for(const indic of data){
      for(const period of this.cadenaEvaluacion){
        const datos = dataAll.filter(
          dat => period.id === dat.idEvaluacion && indic.id === dat.idIndicador  && this.evaluacionEntity.Id_Plantilla === dat.indicadorEntity[0].idPlantilla
        );
        if(datos.length !== 0){
          arrayElemetos = arrayElemetos.concat(datos);
        }
      }
      if(arrayElemetos.length !== 0){
        this.dataOrdenado.push({
          "idEvaluacion":arrayElemetos[arrayElemetos.length-1].idEvaluacion,
          "idIndicador":arrayElemetos[arrayElemetos.length-1].idIndicador,
          "descripcion":arrayElemetos[arrayElemetos.length-1].indicadorEntity[0].descripcion,
          "formula":arrayElemetos[arrayElemetos.length-1].indicadorEntity[0].formula,
          "nivel": arrayElemetos[arrayElemetos.length-1].indicadorEntity[0].nivel-1,
          "check":true,
          "formula1": formulasFunctions.formulas(arrayElemetos[arrayElemetos.length-1].indicadorEntity[0],5),
          "formula2": formulasFunctions.formulas(arrayElemetos[arrayElemetos.length-1].indicadorEntity[0],4),
          "formula3": formulasFunctions.formulas(arrayElemetos[arrayElemetos.length-1].indicadorEntity[0],3),
          "formula4": formulasFunctions.formulas(arrayElemetos[arrayElemetos.length-1].indicadorEntity[0],2),
          "formula5": formulasFunctions.formulas(arrayElemetos[arrayElemetos.length-1].indicadorEntity[0],1),
          "formula6": formulasFunctions.formulas(arrayElemetos[arrayElemetos.length-1].indicadorEntity[0],0),
          "series": arrayElemetos
        });
      }
      arrayElemetos = [];
    }

    const formulas = ['formula1', 'formula2', 'formula3', 'formula4', 'formula5', 'formula6'];
    const filteredFormulas = formulas.map(formula => this.dataOrdenado.filter(c => c[formula] !== '' && c.nivel > 1));

    this.dataOrdenado.forEach(dat => {
      formulas.forEach((formula, index) => {
        if (filteredFormulas[index].length === 0) {
          dat[formula] = 'undefined';
        }
      });
    });
    
    let dataOrdenadoRespaldo = [];
    for (const dat of this.dataOrdenado){
      const ex = this.dataNoInclud.filter(ex => ex === dat.idIndicador);
      if (ex.length === 0){
        dataOrdenadoRespaldo.push(dat);
      }
    }
    this.dataOrdenado = dataOrdenadoRespaldo;
    if(this.dataOrdenado.length === 0){
      var nombre = companiesFinanciero.find(c => Number(c.id) === Number(this.cookieService.get('idInstitucion'))).name;
      messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
    }
    this.dataIndicadores = await this.genFiltroIndicadoresNivel(this.dataOrdenado,0 ,1);          
    this.obtenerDataGrafica();
  }
  private genFiltroIndicadoresNivel(array, pos, nivel, indicador?){
    var aux = [];
    this.dataIndicadores = [];
    for(var i = pos; i < array.length; i++){
      if(array[i].nivel === nivel){
        aux.push({
          "idIndicador":array[i].idIndicador,
          "descripcion":array[i].descripcion,
          "check":true,
          "nivel": array[i].nivel,
          "valor": array[i].series[array[i].series.length-1].valor,
          "textoSemaforo":array[i].series[array[i].series.length-1].textoSemaforo,
          "series": this.genFiltroIndicadoresNivel(array,i+1 ,nivel+1,array[i])
        });
      }else if(array[i].nivel < nivel){
        break;
      }
    }
    return aux;
  }
  /* Graficas */
  private obtenerDataGrafica(){
    var verde = 0, rojo = 0, amarillo = 0, naranja = 0;
    var verdeI = [], rojoI = [], amarilloI = [], naranjaI = [];
    this.subTitlesGraf = this.cadenaEvaluacion[this.cadenaEvaluacion.length-1].periodo
    for(const dat of this.dataOrdenado){
      if(dat.check && dat.nivel !== 1){
        switch(dat.series[dat.series.length-1].textoSemaforo){
          case 'V':
            verde++;
            verdeI.push(dat);
          break;
          case 'A+':
          case 'A':
            amarilloI.push(dat);
            amarillo++;
          break;
          case 'A-':
            naranjaI.push(dat);
            naranja++;
          break;
          case 'R':
            rojoI.push(dat);
            rojo++;
          break;
        }
      }
    }
    this.dataGraficas = [];
    this.etiquetas = [];
    this.etiquetas = [''];
    this.dataGraficas.push(
      {"name":""+this.translate.instant('financiero.razonesFinancieras.titulo2TablaC'), "data":[verde], indicadores: verdeI},
      {"name":""+this.translate.instant('financiero.razonesFinancieras.titulo4TablaC'), "data":[amarillo], indicadores: amarilloI},
      {"name":""+this.translate.instant('financiero.razonesFinancieras.titulo3TablaC'), "data":[naranja], indicadores: naranjaI},
      {"name":""+this.translate.instant('financiero.razonesFinancieras.titulo5TablaC'), "data":[rojo], indicadores: rojoI}
    );    
  }
  /* Obtención de periodos */
  private periodosSeleccionadosAct(){
    var sel = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          sel++;
        }
      }
    }
    return sel;
  }
  private UltimasEvaluaciones(){
    this.cadenaEvaluacion = [];
    this.subTitles = [];
    this.periodosSeleccionados = 0;
    var i=0, cadena = '';
    for(const an of this.Periodos){
      if(an.utilizable){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              evaluacion: mes.periodo,
              periodo: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
    }
    this.getDettalleEvaluacion();
  }
  /* eventos de ocultamiento de columnas */
  public existeOcult(){
    var i =0;
    for(const dat of this.headersCheck){
      if(!dat.check){
        i++;
      }
    }
    if(i>0){
      return true;
    }
    return false;
  }
  public mostrarTodos(){
    for(const dat of this.headersCheck){
      dat.check = true;
    }
  }
  public ocultarTodos(){
    for(const dat of this.headersCheck){
      dat.check = false;
    }
    this.headersCheck[0].check = true;
  }
  /* acciones en filtros */
  public numPerSelect(){
    var selecc = 0;
    for(const an of this.Periodos){
      for(const mes of an.series){
        if(mes.check){
          selecc++;
        }
      }
    }
    if(selecc > 1)
      return true;
    return false;
  }
  public cambioPeriodo(per, op?){
    if( (per.check || (!per.check && this.periodosSeleccionadosAct() < this.numEvaluaciones )) && this.visibleTabla && op == undefined){
      per.check = !per.check;
      this.cadenaEvaluacion = [];
      this.periodosSeleccionados = 0;
      this.subTitles = [];
      var i=0, cadena = '';
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              periodo: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
      this.detalleEvaluacionIndicador.ArregloID_evaluacion = cadena;
      this.getDettalleEvaluacion();
    }else if(this.visibleTarjeta){
      this.periodosSeleccionados = 0;
      for(const an of this.Periodos){
        if(an.utilizable){
          for(const mes of an.series){
            if(mes.periodo === per.periodo){
              mes.check = true;
            }else{
              mes.check = false;
            }
          }
        }
        
      }
      this.cadenaEvaluacion = [];
      this.subTitles = [];
      var i=0, cadena = '';
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.check){
            this.periodosSeleccionados++;
            this.cadenaEvaluacion.push({
              periodo: mes.periodo,
              id: mes.id,
              porcentaje: '%',
            });
            if(i===0){
              this.subTitles.push(mes.periodo);
              cadena = ''+mes.id;
            }else{
              this.subTitles.push(' | ')
              this.subTitles.push(mes.periodo);
              cadena += ','+mes.id;
            }
            i++;
          }
        }
      }
      this.detalleEvaluacionIndicador.ArregloID_evaluacion = cadena;
      this.getDettalleEvaluacion();
      if(this.indSeleccionado !== undefined && op === undefined){
        this.graficaModal(this.indSeleccionado);
      }
    }else if(op == 'reset'){
      // Marcar los últimos 6 periodos
      const series = this.Periodos.flatMap(an => {
        an.series.forEach(mes => mes.check = false);
        return an.series;
      });

      series.slice(-6).forEach(mes => mes.check = true);

      // Construir la información de los periodos seleccionados
      this.periodosSeleccionados = 0;
      this.cadenaEvaluacion = [];
      this.subTitles = [];

      const ids: number[] = [];

      for (const an of this.Periodos) {
        for (const mes of an.series) {
          if (!mes.check) continue;

          this.periodosSeleccionados++;

          this.cadenaEvaluacion.push({
            periodo: mes.periodo,
            id: mes.id,
            porcentaje: '%',
          });

          if (this.subTitles.length) {
            this.subTitles.push(' | ');
          }

          this.subTitles.push(mes.periodo);
          ids.push(mes.id);
        }
      }

      const cadena = ids.join(',');
      this.getDettalleEvaluacion();      
    }else{
      document.getElementById("check_"+per.mes+""+per.anio)['checked'] = false;
      messages.messageGraph(
        'No se pueden seleccionar mas de '+this.numEvaluaciones+' periodos',
        this.translate.instant(''),
        this.translate
      );
    }
  }
  public desactivarIndicadores(ind, check?) {
    if(check === undefined){
      ind.check = !ind.check;
      check = ind.check;
    }else{
      ind.check = check;
    }
    const indOf = this.dataOrdenado.filter(dat => dat.idIndicador === ind.idIndicador)
    if(indOf.length === 1){
      indOf[0].check = check;
      if(ind.series !== undefined && ind.series.length >= 1){
        for(const nivel of ind.series){
          this.desactivarIndicadores(nivel, check);
        }
      }
    }
    this.obtenerDataGrafica();
  }
  public verTitulos(pos){
    if(this.dataOrdenado[pos].nivel === 1){
      for(var i = pos+1; i < this.dataOrdenado.length; i++){
        if(this.dataOrdenado[i].nivel === 1){
          break;
        }
        if(this.dataOrdenado[i].check){
          return true;
        }
      }
      return false;
    }else{
      return false;
    }
  }
  /*Graficas*/
  public changeGrafic1(type){
    switch(type){
      case 'tab':
        this.visibleTabla = true;
        this.visibleTarjeta = false;
        // this.chart.destroy();
        if(this.periodosSeleccionados == 1){
          this.cambioPeriodo(this.cadenaEvaluacion[this.cadenaEvaluacion.length-1], 'reset');

        }
      break;
      case 'tar':
        this.visibleTabla = false;
        this.visibleTarjeta = true;
        if(this.periodosSeleccionados > 1){
          this.cambioPeriodo(this.cadenaEvaluacion[this.cadenaEvaluacion.length-1], 'no');
        }
        this.indSeleccionado = this.dataIndicadores[0].series[0];
        setTimeout(()=>{
          this.graficaModal(this.indSeleccionado);
        },100);
      break;
    }
  }
  public graficaModal(ind){
    this.indSeleccionado = ind;
    var mesSel = false, perAtras = 0, periodos = [];
    for(var i=this.Periodos.length-1; i>=0; i--){
      if(this.Periodos[i].utilizable){
        for(var j=this.Periodos[i].series.length-1; j>=0; j--){
          if(this.Periodos[i].series[j].check===true){
            mesSel = true;
            periodos.push({
              name: this.Periodos[i].series[j].periodo,
              id: this.Periodos[i].series[j].id
            });
            perAtras++;
          }else if(mesSel && perAtras <12){
            periodos.push({
              name: this.Periodos[i].series[j].periodo,
              id: this.Periodos[i].series[j].id
            });
            perAtras++;
          }else if(perAtras ===12){
            break;
          }
        }
      }
      
    }
    this.consultasGraf(periodos, ind)
  }
  private async consultasGraf(periodos, ind){
    try{
      var datos = [];
      for(const eva of periodos){
        const { data } = await firstValueFrom(
          this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
            query: getDetalleIndicador,
            context: { headers: this.headers, },
            variables: { idEvaluacion: eva.id, idIndicador: ind.idIndicador}
          }).valueChanges.source
        );
        datos = datos.concat({
          name: eva.name,
          value: data.detalleEvaluacionIndicador.valor,
          idEvaluacion: data.detalleEvaluacionIndicador.idEvaluacion
        });
      }
      
      datos.sort(function (a, b) {
        if ( moment(FuncionesMes.escrituraPer(a.name)).isAfter(moment(FuncionesMes.escrituraPer(b.name))) ) {
          return 1;
        }
        if ( moment(FuncionesMes.escrituraPer(a.name)).isBefore(moment(FuncionesMes.escrituraPer(b.name))) ) {
          return -1;
        }
        return 0;
      });
      this.opcionesGrafica1(datos);

    }catch(err){
      messages.errorMessageGraph(this.translate.instant(err));
    }
  }
  private opcionesGrafica1(arreglo){
    let data = [], categories = [], values = [];
    for(const dat of arreglo){
      values.push(dat.value);
      categories.push(dat.name);
    }
    this.subTitlesGrafI = categories[0] + " - " + categories[categories.length-1];
    this.dataGrafEvolucion.push({
      name: this.indSeleccionado.descripcion,
      data: values,
    });
    this.etiquetasEvolucion = categories;
  }
  /* formateo de datos */
  public formatingAxis(valor){
    return formatear.retornarformatolefty(valor);
  }
  public escrituraPer(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  /* Modales */
  public openModal(modal){
    this.modalOpen = true;
    this.graf1 = false;
    this.graf2 = false;
    switch(modal){
      case 'graf1': this.graf1 = true; break;
      case 'graf2': this.graf2 = true; break;
    }
  }
  public mostrarColores(color){
    let simil = '', simil2 = '';
    switch(color.serie ){
      case 0: simil = 'V'; break;
      case 1: simil = 'A+'; simil2 = 'A'; break;
      case 2: simil = 'A-'; break;
      case 3: simil = 'R'; break;
    }
    var html = '<div class="w3-row">'+
      '<div class="w3-row">'+
      '  <div style="text-align: justify; margin-left: 1vw; margin-right: 2vw;"> '+ this.translate.instant('financiero.razonesFinancieras.swal1') +' </div>'+
      '</div>'+
      '<mat-list style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">';

    for(const ind of this.dataOrdenado){
      if((ind.series[ind.series.length-1].textoSemaforo === simil || ind.series[ind.series.length-1].textoSemaforo === simil2) && ind.check && ind.nivel !== 1){
        html += '<div mat-line style="text-align: justify; margin-left: 2vw; margin-right: 2vw;">'+
        '<span style="color: #ff6b00">&#8226;</span> '+ind.descripcion+
        '</div>';
      }
    }
    html += '</mat-list>'+'</div>';
    var ancho = 'auto';
    Swal.fire({
      title: ''+ color.name,
      html: html,
      showConfirmButton: false,
      width: ancho+'',
    });
  }
  
  public exportarGraf(id, nombreg?){
    if(id != 'tarjets'){
      var nombre = id == 0 ? this.translate.instant('financiero.razonesFinancieras.tituloEncabezadoTabla2') : this.translate.instant('financiero.razonesFinancieras.tituloZona2Graf');
      var sub = id == 1 ? this.subTitlesGrafI : this.escrituraPer(this.subTitlesGraf)
      var name = { 
        titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
        subtitulo: nombre + " " + sub,
        nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
      }
      
      const comp = this.graficador.find(g => g.zona === id);
      comp.exportImg(id,name);
    }else{
      IMG.exportimagenes(id, this.translate.instant(nombreg));
    }
  }

  public exportExcel(){
    let headers = [];
    for(var i=0; i<this.headersCheck.length; i++){
        headers.push(this.translate.instant('financiero.razonesFinancieras.titulo'+(i+1)+'Tabla'));
    }
    for(const mes of this.cadenaEvaluacion){
      headers.push(this.escrituraPer(mes.periodo));
    }
    let data = [], aux = [], niveles = [], color = [], auxColor = [];
    for(const item of this.dataOrdenado){
      niveles.push(item.nivel);
      aux.push(item.descripcion);
      aux.push(item.nivel!==1?item.formula1:'');
      aux.push(item.nivel!==1?item.formula2:'');
      aux.push(item.nivel!==1?item.formula3:'');
      aux.push(item.nivel!==1?item.formula4:'');
      for(const val of item.series){
        aux.push(item.nivel!==1?Number(val.valor):'');
        auxColor.push(item.nivel!==1?val.textoSemaforo:'');
      }
      data.push(aux);
      color.push(auxColor);
      aux = [];
      auxColor = [];
    }

    let titulo = this.translate.instant('financiero.razonesFinancieras.tituloEncabezadoTabla')+' | ';
    for(const per of this.subTitles){
      titulo += this.escrituraPer(per)
    }

    this.excelService.generateRazonesFinancieras(titulo, headers, data, this.translate.instant('financiero.razonesFinancieras.tituloEncabezadoTabla')+' '+this.escrituraPer(this.subTitles[this.subTitles.length-1]), niveles, color)
  }
}
